// Normalize strings so "RAV4", "Rav 4", "RAV-4" all match
const norm = (s) =>
  (s ?? '').toString().toLowerCase().replace(/\s+/g, '').replace(/-/g, '');

export const fitsVehicle = (product, veh) => {
  if (!product?.fitments?.length || !veh) return false;
  const nMake  = norm(veh.make);
  const nModel = norm(veh.model);
  const y      = Number(veh.year);

  return product.fitments.some((f) => {
    const makeOk  = norm(f.make)  === nMake;
    const modelOk = norm(f.model) === nModel;
    const yearOk  =
      (f.year && Number(f.year) === y)
    return makeOk && modelOk && yearOk;
  });
};
